import './ConfirmationDialog.scss';

export { default } from './ConfirmationDialog';
